import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum EmailChangeFieldIds {
    email = 'email',
    confirmEmail = 'confirmEmail',
}

export enum EmailChangeFieldNames {
  email = 'email',
  confirmEmail = 'confirmEmail',
}

export type EmailAnswersState = {
  primaryEmailField:string;
  [EmailChangeFieldNames.email]: string;
  [EmailChangeFieldNames.confirmEmail]: string;
};

export const initialEmailChangeState: {
  answers: {
    emailFields: EmailAnswersState;
  };
} = {
    answers: {
        emailFields: {
            primaryEmailField: '',
            [EmailChangeFieldNames.email]: '',
            [EmailChangeFieldNames.confirmEmail]: '',
        },
    },
};

const reducers = {
    setAnswers: (
        state,
        action: PayloadAction<{
      [key: string]: Record<EmailChangeFieldNames, string>;
    }>,
    ) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setDefaultInitialEmailState: () => ({
        ...initialEmailChangeState,
    }),
};

const changeEmailSlice = createSlice({
    name: 'changeEmailSlice',
    initialState: initialEmailChangeState,
    reducers,
});

export default changeEmailSlice;
